import { render, staticRenderFns } from "./GeneralSettingView.vue?vue&type=template&id=6afd1486&"
import script from "./GeneralSettingView.vue?vue&type=script&lang=js&"
export * from "./GeneralSettingView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettingView.vue?vue&type=style&index=0&id=6afd1486&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports